import React, { useEffect, useState } from 'react';
import { ScrollView } from 'react-native';
import client from '../../../graphql/client';
import FanGenreButtonList from '../../components/styled/FanGenreButtonList';
import HeaderTwo from '../../components/styled/HeaderTwo';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import View from '../../components/styled/View';

import styles from './styles';
import { SUB_TITLE, TITLE } from './constants';

export default function SessionGenresScreen({ navigation, route }) {
  const initialSongGenre = route?.params?.songGenre[0];
  const initialLimitReached = initialSongGenre.id !== '';
  const [songGenre, setSongGenre] = useState(initialSongGenre);
  const [genresList, setGenres] = useState<any>();
  const [genreSelectionLimitReached, setGenreLimit] = useState<boolean>(
    initialLimitReached,
  );

  const createSubGenresObject = (data) => {
    const obj = data.items.map((item) => {
      return item;
    });
    return obj;
  };

  const createGenresObject = (data) => {
    let obj = {};
    data.items.map((item) => {
      const doesSuperGenreExist = obj.hasOwnProperty(item.superGenre);
      if (doesSuperGenreExist) {
        obj[item.superGenre].push(item);
      } else {
        obj[item.superGenre] = [item];
      }
      return obj;
    });
    return obj;
  };

  const createGenreList = async () => {
    const rawGenreData = await client.getGenres();

    const items = createSubGenresObject(rawGenreData);
    setGenres(items);
  };

  const updateNewGenre = (selectedGenre: any) => {
    if (songGenre.id === selectedGenre.id) {
      setSongGenre({ id: '', genre: '' });
      setGenreLimit(false);
    } else {
      setSongGenre(selectedGenre);
      setGenreLimit(true);
    }
  };

  const updateGenre = async () => {
    navigation.navigate('CreateSession', { updatedGenre: songGenre });
  };

  useEffect(() => {
    createGenreList();
  }, []);

  if (!genresList) return null;

  return (
    <ScrollView>
      <View style={styles.container}>
        <HeaderTwo title={TITLE} style={styles.title} />
        <HeaderTwo title={SUB_TITLE} style={styles.subHeader} />
        {/* <SuperGenreButtonList
          genres={genresList}
          activeGenres={[songGenre]}
          onPress={updateNewGenre}
          limitReached={genreSelectionLimitReached}
          minSelectedThreshold={false}
        /> */}
        <FanGenreButtonList
          genres={genresList}
          activeGenres={[songGenre]}
          onPress={updateNewGenre}
          limitReached={genreSelectionLimitReached}
          minSelectedThreshold={false}
        />
        <View style={styles.buttonContainer}>
          <LinearGradientButton
            disabled={songGenre?.id == ''}
            title="Save"
            onPress={() => updateGenre()}
          />
        </View>
      </View>
    </ScrollView>
  );
}
